<template>
	<div class="goods">
		<div class="content">

			<ul id="normaltab1" class="tabbtn">
				<!-- <li :class="{'current': type === 'all'}" @click="type = 'all'">
                  <a>全部会议</a>
                </li> -->
				<li :class="{'current': isSelect === 0}" @click="isSelect = 0">
					<a>全部风采</a>
				</li>
				<li :class="{'current': isSelect === 1}" @click="isSelect = 1">
					<a>个人风采</a>
				</li>
			</ul>
			<div class="list">
				<p class="warmTip" v-if="list.content && list.content.length<1">没有数据了～</p>
				<ul class="meeting_box">
					<li v-for="(item,index) in list.content" :key="index" >
						<div class="fonts" @click="goDetail(item.id)">
							<h4 >{{item.title}}</h4>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import {Button,Toast } from 'vant';
import {getMemberStyleList,getCurrentAccount} from "@/api/dictionary";
import {getSessionStore} from "@/utils/sessionStorage.js"
export default {
  data() {
    return {
		list:[],
		isSelect:0,
		member:{},
		page:1,
		params:{
			name:null,
			title:null,
			content:"",
			userId:"",
			status:1
		}
    };
  },
  filters: {
    
  },
  components: {
	  [Button.name]: Button,
	  [Toast.name]: Toast,
  },
  methods: {
	  getData() {

		  if(this.isSelect==1){
			  this.params.userId = getSessionStore("userId");
			  delete(this.params.status);
		  }else {
			  this.params.status =1;
			  this.params.userId = "";
		  }
		  getMemberStyleList(this.params, this.page-1)
				  .then(res => {
					  if (res.success) {
						  this.list = res.result;
					  }
				  })
				  .catch(() => {
					  Toast.fail("获取数据失败");
				  });
	  },
	  getMember() {
		  const me = this;
		  let token = getSessionStore("access_token");
		  if (token) {
			  getCurrentAccount({
				  access_token: token
			  })
					  .then(resp => {
						  me.member = resp.result;
						  if (me.member.memberStatus == 1) {
							  $(".noMember").css("display","none");
						  } else {
							  $(".noMember").css("display","block");
							  $(".member").css("display","none");
							  $(".addbottom").css("display","none")
						  }
					  })
					  .catch(err => {});
		  }
	  },
	  goDetail(id){
	  	this.$router.push({name:"memberStyleDetail",query:{"id":id}});
	  }
  },
  computed: {
    
  },
	watch:{
		isSelect(){
			this.getData();
		}
	},
  mounted() {
	  //获取到用户信息  判断他的状态 如果不是正式会员 跳转页面  或者弹出提示 遮罩
	  this.getMember();
	  this.getData();
  }

}
</script>
<style lang="less" scoped>
	.tabbtn{ width: 100%; display: inline-flex; }
	.tabbtn li{ width: 33.3%; text-align: center; font-size:14px; padding: 20px 0; border-bottom: #dfdfdf solid 2px;}
	.tabbtn li.current{ border-color: red }
</style>